import React, { useState } from 'react';
import { Link, useLocation} from 'react-router-dom';
import { GiVendingMachine, GiBoltBomb } from "react-icons/gi";
import { MdOutlineDashboard } from "react-icons/md";
import { FaFirstOrder } from "react-icons/fa";
import { SiMaterialdesign } from "react-icons/si";
import { FaProductHunt } from "react-icons/fa6";
import { IoSettingsOutline } from "react-icons/io5";
import { FaUser } from "react-icons/fa";
import {
  BsList,
} from 'react-icons/bs';

export default function Sidebar() {
  const [isOpen, setIsOpen] = useState(true);
  const location = useLocation();
  const toggleSidebar = () => setIsOpen(!isOpen);

  const isActive = (path) => location.pathname === path;
  const linkClass = (path) =>
    `text-decoration-none d-flex align-items-center gap-2 py-2 px-3 fw-semibold rounded w-100 ${isActive(path)
      ? 'bg-white text-primary border-start border-4 border-primary'
      : 'text-light'
    }`;

  return (
    <div
      className="d-flex flex-column background_color shadow-sm sidebar text-light font_family"
      style={{
        width: isOpen ? '220px' : '70px',
        height: '100vh',
        transition: '0.3s',
        padding: isOpen ? '10px' : '6px'
      }}
    >
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="mb-0 fw-bold  text-white">{isOpen && "Admin Floor Portal"}</h6>
        <button className="btn btn-sm p-1" onClick={toggleSidebar}>
          <BsList size={28} className='text-light' />
        </button>
      </div>

      <ul className="nav nav-pills flex-column text-light flex-grow-1">
        {/* Dashboard */}
        <li className="nav-item">
          <Link to="/admin" className={linkClass('/admin')}>
            <MdOutlineDashboard size={18} />
            {isOpen && <span>Dashboard</span>}
          </Link>
        </li>
         <li className="nav-item">
          <Link to="/admin/users" className={linkClass('/admin/users')}>
            <FaUser size={18} />
            {isOpen && <span>Users</span>}
          </Link>
        </li>

        {/* Machine */}
        <li className="nav-item">
          <Link to="/admin/machine" className={linkClass('/admin/machine')}>
            <GiVendingMachine size={18} />
            {isOpen && <span>Machine</span>}
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/admin/bom" className={linkClass('/admin/bom')}>
            <GiBoltBomb size={18} />
            {isOpen && <span>Bom</span>}
          </Link>
        </li>

        <li className="nav-item">
          <Link to="/admin/material" className={linkClass('/admin/material')}>
            <SiMaterialdesign size={18} />
            {isOpen && <span>Material</span>}
          </Link>
        </li>

        <li className="nav-item">
          <Link to="/admin/product" className={linkClass('/admin/product')}>
            <FaProductHunt size={18} />
            {isOpen && <span>Product</span>}
          </Link>
        </li>

        <li className="nav-item">
          <Link to="/admin/die" className={linkClass('/admin/die')}>
            <FaFirstOrder size={18} />
            {isOpen && <span>Die</span>}
          </Link>
        </li>

        <li className="nav-item">
          <Link to="/admin/training" className={linkClass('/admin/training')}>
            <FaFirstOrder size={18} />
            {isOpen && <span>Training</span>}
          </Link>
        </li>

       <li className="nav-item">
          <Link to="/admin/attendance" className={linkClass('/admin/attendance')}>
            <IoSettingsOutline size={18} />
            {isOpen && <span>Attendance</span>}
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/admin/logspage" className={linkClass('/admin/logspage')}>
            <IoSettingsOutline size={18} />
            {isOpen && <span>Logs</span>}
          </Link>
        </li>
      </ul>
    </div>
  );
}
